@if (legacyStripAllowed() && renderElement) {
  <div
    class="bn-legacy-breadcrumbs-scroll min-w-0 max-w-full overflow-x-auto overflow-y-hidden overscroll-x-contain pt-0 pl-0 pr-4 [-webkit-overflow-scrolling:touch] md:pr-0 md:pt-8 md:pl-16">
    @if (navigating()) {
      <div
        class="h-4 w-64 shrink-0 rounded bg-slate-200 bn-shimmer"
        aria-hidden="true"></div>
    } @else {
      @if (crumbs$ | async; as crumbs) {
        <div
          class="bn-legacy-breadcrumbs-row inline-flex w-max max-w-none flex-nowrap items-end gap-2">
          @for (
            crumb of crumbs;
            let i = $index;
            track i + '-' + (crumb.link ?? '') + '-' + (crumb.text ?? '')
          ) {
            <div class="breadcrumbs shrink-0 items-end gap-2">
              <a class="crumb text-sm whitespace-nowrap" [routerLink]="crumb.link">{{
                crumb.text
              }}</a>
              @if (showSeperator(i, crumbs)) {
                <mat-icon class="material-symbols-rounded crumb-icon shrink-0">
                  chevron_right
                </mat-icon>
              }
            </div>
          }
        </div>
      }
    }
  </div>
}
